// utils/fileUrl.ts

import { fetchAuth } from "./fetchAuth";

export async function generateFileUrl(
  url: string
): Promise<string> {
  const res = await fetchAuth(url);

  if (!res.ok) {
    const errorJson = await res.json();
    throw new Error(`${errorJson.message}`);
  }

  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
